"use strict";

exports.__esModule = true;
exports.addStack = addStack;
exports.removeStack = removeStack;
exports.dispatch = dispatch;

var _detect = require("./dom/detect");

var _uid = require("./uid");

var _document = require("./dom/document");

var throttle = 80;
var components = {};
var timeout = null;
var isLock = false;
var winHeight = _document.docSize.height;

function addStack(obj) {
  var rect = obj.element.getBoundingClientRect();

  if (rect.bottom < 0 || rect.top > winHeight) {
    var id = (0, _uid.getUidStr)();
    components[id] = obj;
    return id;
  }

  obj.render();
  return null;
}

function removeStack(id) {
  if (!id) return;
  delete components[id];
}

function dispatch() {
  if (isLock) return;
  isLock = true; // handle

  Object.keys(components).forEach(function (k) {
    var _components$k = components[k],
        element = _components$k.element,
        render = _components$k.render;
    var rect = element.getBoundingClientRect();
    if (rect.bottom < 0 || rect.top > winHeight) return;
    delete components[k];
    render();
  });
  isLock = false;
} // scroll event


document.addEventListener('scroll', function () {
  if (timeout) clearTimeout(timeout);
  timeout = setTimeout(function () {
    dispatch();
    timeout = null;
  }, throttle);
}, _detect.eventPassive);